import type { KeyboardEvent } from 'react'
import PolePickerOption from './PolePickerOption'
import type { PoleOptionItem } from './usePolePicker'
import { PoleMenu } from './styled-components'

interface PolePickerMenuProps {
  label: string
  width: number
  options: PoleOptionItem[]
  onKeyDown: (event: KeyboardEvent<HTMLElement>) => void
}

const PolePickerMenu = ({ label, width, options, onKeyDown }: PolePickerMenuProps) => (
  <PoleMenu role='listbox' aria-label={label} $width={width} onKeyDown={onKeyDown}>
    {options.map(option => (
      <PolePickerOption key={option.id} option={option} />
    ))}
  </PoleMenu>
)

export default PolePickerMenu
